import {  useState } from "react";
import { EditableField } from "./editable-field";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { PHONE_NUMBER_ARGENTINA_PATTERN } from "../utils/patterns";
import { Button } from "./button";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useToast } from "./toast";
import { useNavigate } from "react-router-dom";
import { InstitutionsAPI } from "../APIs/institutions.api";
import bgCreateTeam from "../assets/bgCreateTeam.jpg";

export function RequestInstitutionForm() {
  const [formData, setFormData] = useState<{
    name: string;
    president: string;
    phone_number: string;
  }>({
    name: "",
    president: "",
    phone_number: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToast();
  const navigate = useNavigate();

  const onChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLSelectElement;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.president || !formData.phone_number) {
      addToast({
        message: "Por favor, rellene todos los campos requeridos",
        type: "error",
        location: "bottom-center",
      });
      return;
    }
    setIsLoading(true);
    try {
      const institutionDto = {
        name: formData.name,
        president: formData.president,
        phone_number: formData.phone_number,
      };

      const response = await InstitutionsAPI.postInstitution({
        institution: institutionDto,
        addresses: [],
      });

      if (response.statusCode === 201) {
        addToast({
          message: "Barra pesquera dada de alta, ahora podes crear tu equipo",
          type: "success",
          location: "bottom-center",
          duration: 15000,
        });
        navigate("/dashboard/");
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (e) {
      addToast({
        message: "Error al dar de alta la barra pesquera, intente nuevamente",
        type: "error",
        location: "bottom-center",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${bgCreateTeam})` }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0" />

      <div className="relative w-full sm:max-w-lg lg:max-w-xl p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10 my-4">
        <div className="flex items-center space-x-2 mb-6 justify-center">
          <InformationCircleIcon className="h-6 w-6 text-gray-800" />
          <h1 className="text-2xl font-bold text-gray-800">
            Alta de nueva barra pesquera
          </h1>
        </div>
        <div className="">
          <form onSubmit={handleSubmit} className="space-y-4">
            <EditableField
              label="Nombre del la barra pesquera"
              value={formData.name}
              onChange={onChange}
              required
              type="text"
              name="name"
              minLength={3}
              maxLength={100}
              placeholder="Ingrese el nombre de la barra pesquera"
              autocomplete="off"
            />
            <EditableField
              label="Nombre del presidente"
              value={formData.president}
              onChange={onChange}
              required
              type="text"
              name="president"
              minLength={3}
              maxLength={100}
              placeholder="Ingrese el nombre del presidente"
              autocomplete="off"
            />
            <EditableField
              label="Número de teléfono"
              value={formData.phone_number}
              onChange={onChange}
              required
              type="text"
              name="phone_number"
              minLength={3}
              maxLength={100}
              pattern={PHONE_NUMBER_ARGENTINA_PATTERN}
              placeholder="Ingrese un número de teléfono"
              autocomplete="off"
            />

            <div className="flex justify-end gap-x-2">
              <Button
                text="Cancelar"
                type="button"
                variant="cancel"
                onClick={() => navigate(-1)}
              />
              <Button
                text="Dar de alta"
                type="submit"
                variant="create"
                icon={<ArrowRightIcon className="w-4 h-4 mr-2" />}
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
